"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconChargingServicesForBusinesses = function IconChargingServicesForBusinesses(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M10.986 13h1.998v2.306A5.97 5.97 0 0 1 16.34 14c2.994 0 5.516 2.779 5.629 5.864l.003.136v24H10.68a24 24 0 0 1-2.6-2h2.907V15H4.994v-2H8.99v-2H6.991V9h3.995zm1.998 29h6.992V22h-6.992zm2.996-4h-.999v-3h1zm1.997 0h-.998v-3h.999zm10.535-2.667L27.1 36.747l-3.117-3.12 1.412-1.414zm12.533-22.114-1.855 1.85 1.336 1.34 1.814-1.816 1.413 1.414-1.815 1.815 1.406 1.408-2.514 2.516a5 5 0 0 1-3.531 1.465 5 5 0 0 1-2.414-.627 2.64 2.64 0 0 0 .336 2.925l.142.154-.514.516.515-.515 4.125 4.14-.01.01a3.913 3.913 0 0 1-2.764 6.68c-.963 0-1.89-.355-2.605-.995l-.16-.152 1.414-1.413a1.907 1.907 0 0 0 2.702-.002 1.91 1.91 0 0 0 .114-2.58l-.114-.125.656-.657-.647.647-4.125-4.14v-.002a4.64 4.64 0 0 1-.605-5.813 5 5 0 0 1 .423-6.587l2.1-2.103h.828l1.08 1.082 1.859-1.852zm-5.682 20.715-1.413 1.413-9.798-9.82 1.413-1.414zM7.99 32h-.999V22h1zm7.99 0h-.999v-3h1zm1.997 0h-.998v-3h.999zM35.18 16.09a3 3 0 0 0-.02 4.223l.144.136a2.996 2.996 0 0 0 4.113-.117l1.102-1.104-4.238-4.242zm-18.77-.092a3.87 3.87 0 0 0-3.402 2.64l-.024.078V20h6.99c-.043-2.086-1.755-4-3.565-4.002"
  })));
};

export { IconChargingServicesForBusinesses, IconChargingServicesForBusinesses as default };
